import React from 'react';

export function TableHead({ children }) {
    return (
        <thead className={'react-table_header'}>
            <tr>{children}</tr>
        </thead>
    );
}
